import ApiClient from './ApiClient';

class CalendarEventsAPI extends ApiClient {
  constructor() {
    super('calendar_events', { accountScoped: true });
  }
}

export default new CalendarEventsAPI();
